<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 统计报表
                </el-breadcrumb-item>
				<el-breadcrumb-item>业绩统计</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-cascader placeholder="请选择员工"
					:options="options" :show-all-levels="false"
					v-model="query.userInfo" filterable clearable>
				</el-cascader>
				&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态" >
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option v-for="item in statusKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-date-picker
						type="month"
						placeholder="月份"
						v-model="query.totalMonth"
						value-format="yyyy-MM"
				></el-date-picker>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				&nbsp;
				<el-button
                    type="primary"
                    icon="el-icon-upload"
                    class="handle-del mr10"
                    @click="handleSendAll"
					v-if="controll['send']"
                >推送全部</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-printer"
                    class="handle-del mr10"
                    @click="handleExportSalaryAll"
					v-if="controll['salary']"
                >导出</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				@selection-change="handleSelectionChange"
				stripe
            >
				<el-table-column type="selection" width="55" align="center" :selectable="isSelectable"></el-table-column>
				<el-table-column prop="totalMonth" label="月份" width="90"></el-table-column>
				<el-table-column prop="userName" label="员工姓名" width="100"></el-table-column>
				<el-table-column prop="newCustomerNum" label="新增客户" width="80"></el-table-column>
                <el-table-column prop="orderNum" label="订单量" width="80"></el-table-column>
				<el-table-column prop="orderAmount" label="订单金额" width="130"></el-table-column>
				<el-table-column prop="profit" label="利润"></el-table-column>
				<el-table-column prop="profitRate" label="利润率" width="100">
					<template slot-scope="scope">
						{{(scope.row.profitRate*100).toFixed(2)}} %
					</template>
				</el-table-column>
				<el-table-column prop="commission" label="提成"></el-table-column>
				<el-table-column prop="teamOrderAmount" label="组成员订单金额" width="130"></el-table-column>
				<el-table-column prop="teamCommission" label="组内提成"></el-table-column>
				<el-table-column prop="status" label="状态" width="90">
					<template slot-scope="scope">
						{{statusFormat(null, null, scope.row.status)}}
					</template>
				</el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show'] && scope.row.totalMonth != '合计'"
                        >详情</el-button>
						<el-button
                            type="text"
                            icon="el-icon-upload"
                            @click="handleSend(scope.$index, scope.row)"
							v-if="controll['send'] && scope.row.status == 0 && scope.row.totalMonth != '合计'"
                        >推送</el-button>
						<el-button
                            type="text"
                            icon="el-icon-printer"
                            @click="handleExportSalary(scope.$index, scope.row)"
							v-if="controll['salary'] && scope.row.status >1 && scope.row.totalMonth != '合计'"
                        >导出</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
					style="float:left"
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleStatic"
					v-if="controll['import']"
                >统计</el-button>
				<el-button
					style="float:left"
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete']"
                >批量删除</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="统计" :visible.sync="staticVisible" width="30%">
			<el-form :model="form" :rules="rules" ref="form" label-width="120px">
				<el-form-item label="统计月份" prop="totalMonth">
					<el-date-picker
							type="month"
							placeholder="月份"
							v-model="form.totalMonth"
							value-format="yyyy-MM"
					></el-date-picker>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="staticVisible = false">取 消</el-button>
				<el-button type="primary" @click="static">确定</el-button>
            </span>
		</el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="导出" :visible.sync="exportVisible" width="30%">
			<el-form :model="form" :rules="rules" ref="form" label-width="120px">
				<el-form-item label="导出月份" prop="totalMonth">
					<el-date-picker
							type="month"
							placeholder="月份"
							v-model="form.totalMonth"
							value-format="yyyy-MM"
					></el-date-picker>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="exportVisible = false">取 消</el-button>
				<el-button type="primary" @click="exportData">确定</el-button>
            </span>
		</el-dialog>
				
		<el-dialog v-dialogDrag :close-on-click-modal=false title="详情" :visible.sync="showVisible" width="75%">
			<el-tabs v-model="activeName" type="card">
				<el-tab-pane label="基本信息" name="baseTab">
					<el-form ref="show" :model="show">
						<el-descriptions class="margin-top" title="" :column="3" size="medium" labelStyle="width:150px;" border>
							<el-descriptions-item>
								<template slot="label">
									业绩月份
								</template>
								{{show.totalMonth}}
							</el-descriptions-item>
							<el-descriptions-item span = 2>
								<template slot="label">
									员工姓名
								</template>
								{{show.userName}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									不计提成利润率
								</template>
								{{(show.noChargedRate*100).toFixed(2)}}%
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									默认成本率
								</template>
								{{(show.defaultCostRate*100).toFixed(2)}}%
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									未税成本率
								</template>
								{{(show.taxExcludedCostRate*100).toFixed(2)}}%
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									新增客户数
								</template>
								{{show.newCustomerNum}}
							</el-descriptions-item>
							<el-descriptions-item span = 2>
								<template slot="label">
									订单量
								</template>
								{{show.orderNum}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									订单总金额
								</template>
								{{show.orderAmount}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									订单利润
								</template>
								{{show.profit}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									订单平均利润率
								</template>
								{{(show.profitRate*100).toFixed(2)}}%
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									个人提成计算方式
								</template>
								{{show.businessCalculationMethod==0?"按销售额计算":"按利润计算"}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									个人提成比例
								</template>
								{{(show.businessCommissionScale*100).toFixed(2)}}%
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									个人业务责任额
								</template>
								{{show.businessLiabilityAmount}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									提成计算销售额
								</template>
								{{show.businessOrderAmount}}
							</el-descriptions-item>
							<el-descriptions-item span=2>
								<template slot="label">
									个人业务提成
								</template>
								{{show.commission}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									团队销售额
								</template>
								{{show.teamOrderAmount?show.teamOrderAmount:"--"}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									团队责任额
								</template>
								{{show.manageLiabilityAmount?show.manageLiabilityAmount:"--"}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									团队提成比例
								</template>
								{{show.manageLiabilityAmount?(show.manageCommissionScale*100).toFixed(2)+"%":"--"}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									团队提成计算销售额
								</template>
								{{show.teamOrderAmount?show.teamOrderAmount:"--"}}
							</el-descriptions-item>
							<el-descriptions-item span=2>
								<template slot="label">
									团队提成
								</template>
								{{show.teamCommission?show.teamCommission:"--"}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									状态
								</template>
								{{statusFormat(null, null, show.status)}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									备注
								</template>
								{{show.remark}}
							</el-descriptions-item>
						</el-descriptions>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="内容信息" name="detailTab">
					<el-table
						:data="detailData"
						border
						class="table"
						header-cell-class-name="table-header"
						:cell-style="{padding:4+'px'}"
						height="400px"
						stripe
					>
						<el-table-column prop="orderNo" label="订单号" width="130"></el-table-column>
						<el-table-column prop="companyName" label="公司名称" width="300"></el-table-column>
						<el-table-column prop="taxIncluded" label="是否含税" width="80">
							<template slot-scope="scope">
								{{scope.row.taxIncluded?'含税':'不含税'}}
							</template>
						</el-table-column>
						<el-table-column prop="productName" label="型号"></el-table-column>
						<el-table-column prop="num" label="数量" width="90"></el-table-column>
						<el-table-column prop="amount" label="金额（元）" width="100"></el-table-column>
						<el-table-column prop="cost" label="成本（元）" width="100"></el-table-column>
						<el-table-column prop="profit" label="利润（元）" width="100"></el-table-column>
						<el-table-column prop="profitRate" label="利润率" width="90">
							<template slot-scope="scope">
								{{(scope.row.profitRate*100).toFixed(2)}} %
							</template>
						</el-table-column>
						<el-table-column prop="commission" label="提成（元）" width="100" v-if="show.businessCalculationMethod==1">
							<template slot-scope="scope">
								{{scope.row.commission==0?"--":scope.row.commission}}
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
			</el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showVisible = false" v-prevent-re-click>取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchAchievementData, getAchievement, getUserKV, sendAchievement, exportAchievementDetail, 
importAchievement, buildAchievement, deleteAchievement, getDepartmentUserTree } from '../../../api/index';
export default {
    name: 'achievement',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
			showVisible: false,
			isDisabled:false,
			importData:[],
			detailData:[],
			staticVisible: false,
			exportVisible: false,
			activeName:"baseTab",
            pageTotal: 0,
			uuid:"",
			show:{},
			statusKV:[{"key":0,"value":"待推送"},{"key":1,"value":"已推送"},{"key":2,"value":"已确认"},{"key":3,"value":"已核算"}],
			userKV:[],
			controll:{},
			multipleSelection:[],
			form:{},
			rules:{
                totalMonth: [{ required: true, message: '请选择统计月份', trigger: 'blur' }]
            },
			options:[]
        };
    },
    created() {
		this.controll = getControll("achievement");
		this.getUser();
        this.getData();
    },
    methods: {
		statusFormat(row, column, cellValue) {
			let statusConfig = {"0":"待推送", "1":"待确认", "2":"已确认", "3":"已核算"};
			return statusConfig[cellValue];
		},
		isSelectable(row, index) {
			return row.status < 2;
		},
		getUser() {
			getDepartmentUserTree().then(res => {
				if (res.code == 0 ) {
					this.options = res.data;
				} else {
					this.$message.error("获取用户信息失败，" + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
			this.activeName = "baseTab";
			if (this.query.userInfo != undefined) {
				this.$set(this.query, "userId", this.query.userInfo[this.query.userInfo.length - 1]);
			} else {
				this.$set(this.query, "userId", undefined);
			}
            fetchAchievementData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
					let newCustomerNum = 0;
					let orderNum = 0;
					let orderAmount = 0;
					let profit = 0;
					let profitRate = 0;
					let commission = 0;
					let teamOrderAmount = 0;
					let teamCommission = 0;
					for (var i = 0; i < this.tableData.length; i++) {
						newCustomerNum = this.tableData[i].newCustomerNum + newCustomerNum;
						orderNum = this.tableData[i].orderNum + orderNum;
						orderAmount = this.tableData[i].orderAmount + orderAmount;
						profit = this.tableData[i].profit + profit;
						commission = this.tableData[i].commission + commission;
						teamOrderAmount = this.tableData[i].teamOrderAmount==undefined?0:this.tableData[i].teamOrderAmount + teamOrderAmount;
						teamCommission = this.tableData[i].teamCommission==undefined?0:this.tableData[i].teamCommission==undefined + teamCommission;
					}
					let totalRecord = {};
					totalRecord.totalMonth = "合计";
					totalRecord.newCustomerNum = newCustomerNum;
					totalRecord.orderNum = orderNum;
					totalRecord.orderAmount = orderAmount.toFixed(2);
					totalRecord.profit = profit.toFixed(2);
					totalRecord.profitRate = orderAmount == 0 ? 0.00 : (profit/orderAmount).toFixed(4);
					totalRecord.commission = commission.toFixed(2);
					totalRecord.teamOrderAmount = teamOrderAmount.toFixed(2);
					totalRecord.teamCommission = teamCommission.toFixed(2);
					this.tableData.push(totalRecord);
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		handleSendAll() {
			this.handleSend(undefined, {"id":-1});
		},
		handleSend(index, row) {
			this.$confirm('确定要推送吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					sendAchievement(row.id).then(res => {
						if (res.code == 0) {
							this.$message.success('推送成功');
							this.getData();
						} else {
							this.$message.error(`推送失败！` + res.message);
						}
					});
                })
                .catch(() => {});
		},
		//详情操作
		handleShow(index, row) {
			getAchievement(row.id).then(res => {
				if (res.code == 0) {
				    this.show = row;
					this.detailData = res.data.details;
					this.showVisible = true;
					this.activeName = "baseTab";
				} else {
					this.$message.error(`获取详情失败！` + res.message);
				}
			});
		},
		//导出业绩
		handleExportSalary(index, row) {
			this.exportSalary(row.id, undefined);
		},
		handleExportSalaryAll() {
			this.$set(this.form, 'totalMonth', '');
			this.exportVisible = true;
		},
		exportData() {
			this.exportSalary(undefined, this.form.totalMonth);
		},
        // 导出业绩
		exportSalary(id, totalMonth) {
			let param = {};
			param.id = id;
			param.totalMonth = totalMonth;
			exportAchievementDetail(param).then(res => {
				if (res.code == 0) {
					var linkTag = document.createElement("a");
					linkTag.href = "/blob/export/achievement-detail?key=" + res.data;			
					linkTag.click();
					linkTag.remove();
					this.exportVisible = false;
				} else {
					this.$message.error(`提成表生成失败！` + res.message);
				}
			});
		},
		handleStatic() {
			this.$set(this.form, 'totalMonth', '');
			this.staticVisible = true;
		},
		static() {
			buildAchievement(this.form.totalMonth).then(res => {
				if (res.code == 0) {
					this.$message.success('统计完成');
					this.staticVisible = false;
					this.getData();
				} else {
					this.$message.error(`统计失败！` + res.message);
				}
			});
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		// 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		//获取id
		getIds() {
			let ids = [];
			const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			return ids;
		},
		//删除
        delAllSelection() {
            let ids = this.getIds();
			if (ids.length == 0) {
				return;
			}
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteAchievement(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
